$(window).on('load',function(){

  const luxePage = document.querySelector('.luxePage');
  if(luxePage) {
    const luxeMvImageList = document.querySelectorAll('.js-luxe-mv-image');
    const luxeMvIframeList = document.querySelectorAll('.js-luxe-mv-iframe');
    const luxeWatchList = document.querySelectorAll('.js-luxe-watch');
    
    let index = luxePage.dataset.index;
    index = index ? index : 12;
    var random = Math.floor( Math.random() * index );

    luxeMvImageList.forEach(el => {
      el.classList.remove('is-show')
    })
    luxeMvImageList[random].classList.add('is-show')

    luxeMvIframeList.forEach(el => {
      el.classList.remove('is-show')
    })
    luxeMvIframeList[random].classList.add('is-show')

    // ６つの時計をランダム表示
    let watchRandams = [];
    var min = 1, max = luxeWatchList.length;
    
    for(i = min; i <= 6; i++){
      while(true){
        var tmp = intRandom(min, max);
        if(!watchRandams.includes(tmp)){
          watchRandams.push(tmp);
          break;
        }
      }
    }
    function intRandom(min, max){
      return Math.floor( Math.random() * (max - min + 1)) + min;
    }

    luxeWatchList.forEach((el, index) => {
      let indexTmp = index + 1
      el.classList.remove('is-show')
      if(watchRandams.includes(indexTmp)) {
        el.classList.add('is-show')
      }
    })
  }
  
});